import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { RequestTypes } from '../requestTypes'
import { checklistTemplateKeys } from '@core/react-query/features/templates/checklistTemplates'
import {
  IChecklistTemplateRole,
  ChecklistTemplateRole,
} from '@core/entities/checklist/ChecklistTemplateRoles'
import { RequestErrorType } from '@core/utils/api-axios-instance'

const checklistTemplateRolesTransform = (response: IChecklistTemplateRole[]) =>
  response.map(ChecklistTemplateRole.new)

export const useGetChecklistTemplateRoles = (
  payload: RequestTypes['getChecklistTemplateRoles'],
  options?: UseQueryOptions<
    IChecklistTemplateRole[],
    RequestErrorType,
    ChecklistTemplateRole[]
  >,
) => {
  return useQuery({
    select: checklistTemplateRolesTransform,
    ...checklistTemplateKeys.getRoles(payload),
    ...options,
  })
}
